import { createSlice } from "@reduxjs/toolkit";

export const alertSlice = createSlice({
    name: 'alert',
    initialState: {
        alertStatus: false,
        alertMessage: "",
        alertSeverity: "info",
    },
    reducers: {
        showAlert: (state, action) => {
            const { status, message, severity } = action.payload;

            state.alertStatus = status;
            state.alertMessage = message;
            state.alertSeverity = severity;
        },

        setAlertStatus: (state, action) => {
            state.alertStatus = action.payload;
        },
        setAlertMessage: (state, action) => {
            state.alertMessage = action.payload;
        },
        setAlertSeverity: (state, action) => {
            state.alertSeverity = action.payload;
        },
    },
    extraReducers: (builder) => { },
});

export const { showAlert, setAlertStatus, setAlertMessage, setAlertSeverity } = alertSlice.actions;

export default alertSlice.reducer;